import { render, staticRenderFns } from "./AccountIcon.vue?vue&type=template&id=824d45e8&scoped=true&"
import script from "./AccountIcon.vue?vue&type=script&lang=js&"
export * from "./AccountIcon.vue?vue&type=script&lang=js&"
import style0 from "./AccountIcon.vue?vue&type=style&index=0&id=824d45e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824d45e8",
  null
  
)

export default component.exports